import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import {
  ElectronicSignatureDialogData,
} from '../../../../models/ts/electronic-signature-response-dto.model';
import { DatePipe, NgIf } from '@angular/common';
import { EditorModule } from '@progress/kendo-angular-editor';
import { ExtensionIconComponent } from '../ui/icon/extension-icon/extension-icon.component';
import { IconComponent } from '../ui/icon/icon.component';
import { MailingAttachmentsUploadComponent } from '../../../features/bizzmine/form/components/controls/form-mailing-list/mailing-attachments-upload/mailing-attachments-upload.component';
import { SharedFilterModule } from '@progress/kendo-angular-grid';
import { TooltipModule } from '@progress/kendo-angular-tooltip';
import { TranslatePipe } from '../../pipes/translate/translate.pipe';
import { BehaviorSubject, take } from 'rxjs';
import { HttpRequest } from '@angular/common/http';
import { LoaderButtonComponent } from '../loader-button/loader-button/loader-button.component';
import { Store } from '@ngrx/store';
import { viewStackActions } from 'src/app/store/features/forms/view-stack-actions';
import { AiApiService } from '../../../api/bizzmine/ai/ai-api.service';
import { PopUpModalType } from '../../enums/popup-modal-type';
import { UsageMeterType } from '../../enums/usage-meter-type';
import { ExamGenerationIntent } from 'src/models/ts/exam-generation-intent';

@Component({
  selector: 'bizz-electronic-signature-dialog',
  standalone: true,
  imports: [
    DatePipe,
    EditorModule,
    IconComponent,
    SharedFilterModule,
    TooltipModule,
    TranslatePipe,
    LoaderButtonComponent,
  ],
  templateUrl: './ai-first-time-dialog.component.html',
  styleUrl: './ai-first-time-dialog.component.scss'
})
export class AiFirstTimeDialogComponent implements OnDestroy, OnInit {
  public data: {PopUpModalType: PopUpModalType, PopUpModelText: string, PopupModelMessage: string, UsageMeterType: UsageMeterType}
  public isExamnAi: false;
  public intent: ExamGenerationIntent | undefined = undefined;
  public newRequest$: BehaviorSubject<HttpRequest<unknown> | null> = new BehaviorSubject<HttpRequest<unknown> | null>(null);
  public isLoading = false;

  public constructor(
    public dialogRef: DialogRef,
    @Inject(DIALOG_DATA)
    public params: any,
    private aiApiService: AiApiService,
    private store$: Store
  ) {
    this.data = params.error.error;
    //Params for AI exam generation
    this.isExamnAi = params.isexamai;
    this.intent = params.intent;
  }

  public ngOnDestroy(): void {
    if (this.newRequest$) {
      this.newRequest$.complete();
    }
  }

  public ngOnInit(): void {
    this.store$.dispatch(viewStackActions.removeLoadingStateWithLatestForm());
  }

  public confirm(): void {
    this.isLoading = true;
    this.confirmAiUse();
  }

  public confirmAiUse(): void {

      switch (this.data.PopUpModalType) {
        case PopUpModalType.AiFirstTimeUse: {
          //First time use so we need to confirm the use of AI
          this.aiApiService.confirmAiUse().pipe(take(1)).subscribe({
            error: (): void => {
              this.isLoading = false;
            },
            complete: (): void => {
              //needed to check if the intent is defined, because in case of exam generation we need to invoke the generate with ai intent
              if (this.isExamnAi && this.intent !== undefined) {
                this.isLoading = false;
                this.close(true);
              }else{
                //intercepted by api so we know this is not with singalR
                this.newRequest$.next(this.params.request.clone({ headers: this.params.request.headers }));
                this.isLoading = false;
                this.close();
              }
            }
          });
          break;
        }
        case PopUpModalType.AiTemporarilyUnavailable: {
          //needed to check if the intent is defined, because in case of exam generation we need to invoke the generate with ai intent
          if (this.isExamnAi && this.intent !== undefined) {
            this.isLoading = false;
            this.close(true);
          }else{
            //intercepted by api so we know this is not with singalR
            this.newRequest$.next(this.params.request.clone({ headers: this.params.request.headers }));
            this.isLoading = false;
            this.close();
          }
          break;
        }
        case PopUpModalType.AiContentFiltering:
        case PopUpModalType.UsageCreditsExceeded: {
          this.isLoading = false;
          this.close();
          break;
        }
      }
  }

  public close(isExamnRetry: boolean = false): void {
    this.dialogRef.close(isExamnRetry);
  }

  protected readonly viewStackActions = viewStackActions;
  protected readonly PopUpModalType = PopUpModalType;
  protected readonly UsageMeterType = UsageMeterType;
}

export interface AiFirstTimeHeader {
  key: string;
  value: string;
}
